import { useMemo } from 'react';
import classNames from 'classnames';
import { useMediaQuery } from 'common/hooks';

import { useStyles } from '../ui/styles';

const useModalClasses = (showPartContent: boolean) => {
  const { isMobile } = useMediaQuery();
  const classes = useStyles({ isMobile });

  const modalClasses = useMemo(
    () => ({
      content: {
        root: classNames({
          [classes.contentRootMobile]: isMobile,
          [classes.contentRoot]: true,
        }),
      },
      dialog: {
        root: classNames({
          [classes.dialogRootPartMobile]: isMobile && !showPartContent,
          [classes.dialogRoot]: true,
        }),
      },
      title: {
        root: classes.titleRoot,
      },
      titleArrowButton: classes.titleArrowButton,
    }),
    [isMobile, showPartContent, classes]
  );

  return modalClasses;
};

export default useModalClasses;
